import { render, staticRenderFns } from "./RPRichmenuClick.vue?vue&type=template&id=6447d628"
import script from "./RPRichmenuClick.vue?vue&type=script&lang=js"
export * from "./RPRichmenuClick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports